import {
    QUICK_CHECKOUT_ACTIVATED_FLAG_NAME,
    QUICK_CHECKOUT_INITIALIZED,
    HTO_ITEMS_IDS,
} from 'constants/quickCheckout';

import {localStore} from 'libs/storage/storage';

/**
 * Determines is quick checkout active or not
 * @returns {boolean} quick checkout activated flag
 */
export const isQuickCheckoutActivated = (): boolean =>
    localStore.get(QUICK_CHECKOUT_ACTIVATED_FLAG_NAME);

/**
 * Get is quick checkout flag from local storage
 * @return {boolean} - is quick checkout initialized
 */
export const getIsQuickCheckoutInitialized = (): boolean =>
    localStore.get(QUICK_CHECKOUT_INITIALIZED);

/**
 * Get true if QUICK_CHECKOUT_INITIALIZED flag is true
 * and we are not on checkout page
 * @returns {boolean} - is quick checkout step
 */
export const isQuickCheckoutInitialized = () =>
    Boolean(
        getIsQuickCheckoutInitialized() &&
            window.location.pathname.indexOf('checkout/onepage/') === -1,
    );

/**
 * Get array of ids or array with empty string
 * @return {string[]} - ids hto items which to be enabled
 */
export const getSavedHtoItems = (): string[] => localStore.get(HTO_ITEMS_IDS, ['']);
